export default "__VITE_ASSET__D3GTet9j__"